<script lang="ts">
    import { Dialog, Modal, Tabs } from "attractions";
    import AddNewProduct from "./AddNewProduct.svelte";
    import ExportProducts from "./ExportProducts.svelte";
    import ImportProducts from "./ImportProducts.svelte";
    import ListProducts from "./ListProducts.svelte";

    export let open: boolean;

    const availableTabs = ["Wszystkie", "Import", "Eksport"];
    let selectedTab = availableTabs[0];
</script>

<Modal bind:open let:closeCallback>
    <Dialog title="Baza produktów" {closeCallback}>
        <Tabs
            class="modalTabs"
            name="menu"
            items={availableTabs}
            bind:value={selectedTab}
        />
        <section class="modalContent">
            {#if selectedTab == availableTabs[0]}
                <AddNewProduct />
                <ListProducts />
            {/if}
        </section>
        {#if selectedTab == availableTabs[1]}
            <ImportProducts />
        {/if}
        {#if selectedTab == availableTabs[2]}
            <ExportProducts />
        {/if}
    </Dialog>
</Modal>